import React, { FC } from 'react';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { useSettings } from '@wix/tpa-settings/react';
import { Text, TextTypography as TYPOGRAPHY } from '@wix/wix-ui-tpa/cssVars';
import { classes, st } from './ServiceTitle.st.css';
import settingsParams from '../../../../../settingsParams';

export type ServiceTitleProps = {
  title: string;
  id?: string;
};

export const ServiceTitle: FC<ServiceTitleProps> = ({ title, id }) => {
  const { isMobile } = useEnvironment();
  const settings = useSettings();
  const tagName = settings.get(settingsParams.serviceNameFontHtmlTag);

  return (
    <div className={st(classes.root, { isMobile })}>
      <Text
        id={id}
        className={classes.title}
        typography={TYPOGRAPHY.smallTitle}
        tagName={tagName}
      >
        {title}
      </Text>
    </div>
  );
};
